// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*HeroA.css*/
/* General Styles */
.hero-section {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #000;
  overflow: hidden;
  background-size: cover;
  background-position: center;
}

/* Background stars with a parallax effect */
.hero-background-stars {
  background: #000 url('https://www.transparenttextures.com/patterns/stardust.png') repeat top center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-size: cover;
  animation: starAnimation 200s linear infinite;
}

@keyframes starAnimation {
  from {
    background-position: 0 0;
  }
  to {
    background-position: -10000px 5000px;
  }
}

/* Hero Content */
.hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 90%;
  padding: 20px;
}

/* Moon Styling */
.hero-moon-container {
  position: relative;
  width: 250px;
  height: 250px;
  border-radius: 50%;
  overflow: hidden;
}

.hero-rotating-moon {
  position: absolute;
  width: 100%;
  height: 100%;
  background-repeat: repeat;
  background-size: cover;
  border-radius: 50%;
  animation: moonRotate 50s linear infinite;
  box-shadow: inset 10px 0 5px rgba(0, 0, 0, 0.5),
    inset 1px 0 5px rgba(0, 0, 0, 0.9),
    inset 0px 0 5px rgba(248, 248, 213, 0.2);
}

/* Moon rotation */
@keyframes moonRotate {
  0% {
    background-position: 0 center;
  }
  100% {
    background-position: 100% center;
  }
}

/* Pulsing animation */
@keyframes moonPulse {
  0% {
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.2);
  }
  50% {
    box-shadow: 0 0 50px rgba(255, 255, 255, 0.5);
  }
  100% {
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.2);
  }
}

/* Logo animation */
.hero-image-logo {
  margin-top: 50px;
  width: 250px;
  height: auto;
  margin-bottom: 20px;
  animation: logoBounce 5s ease infinite;
}

@keyframes logoBounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Text */
.hero-text {
  margin-top: 30px;
  font-size: 1.5rem;
  margin-bottom: 20px;
  max-width: 600px;
  animation: pulseText 3s ease-in-out infinite;
}

@keyframes pulseText {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}

/* Social Links */
.hero-social-links {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 40px;
}

.hero-social-icon {
  width: 50px;
  height: 50px;
  filter: grayscale(100%);
  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;
  opacity: 0.7;
}

.hero-social-icon:hover {
  transform: scale(1.2);
  filter: grayscale(100%);
}

/* Responsive Styles */
@media (max-width: 768px) {
.hero-section {
    height: 70vh;
  }

  .hero-moon-container {
    width: 250px;
    height: 250px;
  }

  .hero-image-logo {
    width: 250px;
  }

  .hero-text {
    font-size: 1.2rem;
  }
  .hero-social-icon {
    width: 40px;
    height: 40px;
  }
}

@media (max-width: 480px) {
  .hero-section {
    height: 70vh;
  }
  .hero-moon-container {
    width: 150px;
    height: 150px;
  }

  .hero-image-logo {
    width: 150px;
  }

  .hero-text {
    font-size: 1rem;
    padding: 0 10px;
  }

  .hero-social-icon {
    width: 30px;
    height: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/components/HeroA.css"],"names":[],"mappings":"AAAA,YAAY;AACZ,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,4CAA4C;AAC5C;EACE,mGAAmG;EACnG,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC;;4CAE0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,uEAAuE;EACvE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;AACA;IACI,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/*HeroA.css*/\r\n/* General Styles */\r\n.hero-section {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  background-color: #000;\r\n  overflow: hidden;\r\n  background-size: cover;\r\n  background-position: center;\r\n}\r\n\r\n/* Background stars with a parallax effect */\r\n.hero-background-stars {\r\n  background: #000 url('https://www.transparenttextures.com/patterns/stardust.png') repeat top center;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 0;\r\n  background-size: cover;\r\n  animation: starAnimation 200s linear infinite;\r\n}\r\n\r\n@keyframes starAnimation {\r\n  from {\r\n    background-position: 0 0;\r\n  }\r\n  to {\r\n    background-position: -10000px 5000px;\r\n  }\r\n}\r\n\r\n/* Hero Content */\r\n.hero-content {\r\n  position: relative;\r\n  z-index: 1;\r\n  text-align: center;\r\n  color: #fff;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  max-width: 90%;\r\n  padding: 20px;\r\n}\r\n\r\n/* Moon Styling */\r\n.hero-moon-container {\r\n  position: relative;\r\n  width: 250px;\r\n  height: 250px;\r\n  border-radius: 50%;\r\n  overflow: hidden;\r\n}\r\n\r\n.hero-rotating-moon {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-repeat: repeat;\r\n  background-size: cover;\r\n  border-radius: 50%;\r\n  animation: moonRotate 50s linear infinite;\r\n  box-shadow: inset 10px 0 5px rgba(0, 0, 0, 0.5),\r\n    inset 1px 0 5px rgba(0, 0, 0, 0.9),\r\n    inset 0px 0 5px rgba(248, 248, 213, 0.2);\r\n}\r\n\r\n/* Moon rotation */\r\n@keyframes moonRotate {\r\n  0% {\r\n    background-position: 0 center;\r\n  }\r\n  100% {\r\n    background-position: 100% center;\r\n  }\r\n}\r\n\r\n/* Pulsing animation */\r\n@keyframes moonPulse {\r\n  0% {\r\n    box-shadow: 0 0 30px rgba(255, 255, 255, 0.2);\r\n  }\r\n  50% {\r\n    box-shadow: 0 0 50px rgba(255, 255, 255, 0.5);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 30px rgba(255, 255, 255, 0.2);\r\n  }\r\n}\r\n\r\n/* Logo animation */\r\n.hero-image-logo {\r\n  margin-top: 50px;\r\n  width: 250px;\r\n  height: auto;\r\n  margin-bottom: 20px;\r\n  animation: logoBounce 5s ease infinite;\r\n}\r\n\r\n@keyframes logoBounce {\r\n  0%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-10px);\r\n  }\r\n}\r\n\r\n/* Text */\r\n.hero-text {\r\n  margin-top: 30px;\r\n  font-size: 1.5rem;\r\n  margin-bottom: 20px;\r\n  max-width: 600px;\r\n  animation: pulseText 3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes pulseText {\r\n  0%,\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    opacity: 0.8;\r\n    transform: scale(1.05);\r\n  }\r\n}\r\n\r\n/* Social Links */\r\n.hero-social-links {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 15px;\r\n  margin-top: 40px;\r\n}\r\n\r\n.hero-social-icon {\r\n  width: 50px;\r\n  height: 50px;\r\n  filter: grayscale(100%);\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;\r\n  opacity: 0.7;\r\n}\r\n\r\n.hero-social-icon:hover {\r\n  transform: scale(1.2);\r\n  filter: grayscale(100%);\r\n}\r\n\r\n/* Responsive Styles */\r\n@media (max-width: 768px) {\r\n.hero-section {\r\n    height: 70vh;\r\n  }\r\n\r\n  .hero-moon-container {\r\n    width: 250px;\r\n    height: 250px;\r\n  }\r\n\r\n  .hero-image-logo {\r\n    width: 250px;\r\n  }\r\n\r\n  .hero-text {\r\n    font-size: 1.2rem;\r\n  }\r\n  .hero-social-icon {\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .hero-section {\r\n    height: 70vh;\r\n  }\r\n  .hero-moon-container {\r\n    width: 150px;\r\n    height: 150px;\r\n  }\r\n\r\n  .hero-image-logo {\r\n    width: 150px;\r\n  }\r\n\r\n  .hero-text {\r\n    font-size: 1rem;\r\n    padding: 0 10px;\r\n  }\r\n\r\n  .hero-social-icon {\r\n    width: 30px;\r\n    height: 30px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
